export enum PolicyTypePayment {
  Persona = "PER",
  "Riesgos Generales" = "RG",
}
